/**
 * Reading Level Page
 * Dynamic route component for displaying books at a specific reading level
 */

import { useLocation, Navigate } from 'react-router-dom'
import Layout from '@components/layout/Layout'
import BookCard from '@components/books/BookCard'
import { BOOKS_DATA, LEVELS_DATA } from '@data/books'
import type { BookData } from '@data/books'

export default function ReadingLevel() {
  const location = useLocation()
  // Extract levelId from pathname (e.g., "/countdown" -> "countdown")
  const levelId = location.pathname.replace('/', '')

  // Find the level data
  const level = LEVELS_DATA.find(l => l.id === levelId)

  // If level not found, redirect to home
  if (!level) {
    return <Navigate to="/" replace />
  }

  const books: BookData[] = BOOKS_DATA[levelId] || []

  return (
    <Layout heroImage={level.heroImage} heroAlt={level.alt}>
      <h1>{level.name}</h1>
      <div className="book-grid">
        {books.map((book, index) => (
          <BookCard key={`${book.title}-${index}`} book={book} />
        ))}
      </div>
    </Layout>
  )
}
